export default __webpack_public_path__ + "static/media/News & Announcements.e418023c.svg";